import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/admin" element={<Admin />} />
                </Routes>
                <Toaster
                    position="bottom-center"
                    toastOptions={{
                        style: {
                            background: "#141414",
                            border: "1px solid #27272A",
                            color: "#FFFFFF",
                        },
                    }}
                />
            </BrowserRouter>
        </div>
    );
}

export default App;
